import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import { Callback } from "./pages/Callback";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import theme from "./helpers/theme";
import { ThemeProvider } from "@mui/material";
import VendorOnboardingRouter from "./pages/VendorOnboarding/VendorOnboardingRouter";
import VendorOnboardingLogin from "./pages/VendorOnboarding/Login";
import VendorOnboardingStatus from "./pages/VendorOnboarding/Status";
import VendorAuthGate from "./pages/VendorOnboarding/components/VendorAuthGate";
import VendorPortalShell from "./pages/VendorOnboarding/components/VendorPortalShell";
import TarsAuthGate from "./pages/VendorOnboarding/components/TarsAuthGate";
import ReviewerRouter from "./pages/VendorOnboarding/reviewer/ReviewerRouter";

function App() {
  // Create a client
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/callback" element={<Callback />}></Route>
          <Route path="/dashboard/*" element={<Dashboard />}></Route>
          <Route path="/vendor-onboarding/login" element={<VendorPortalShell><VendorOnboardingLogin /></VendorPortalShell>}></Route>
          <Route path="/vendor-onboarding" element={<VendorOnboardingRouter />}></Route>
          <Route path="/vendor-onboarding/status" element={<VendorAuthGate><VendorPortalShell><VendorOnboardingStatus /></VendorPortalShell></VendorAuthGate>}></Route>
          <Route path="/vendor-onboarding/review" element={<TarsAuthGate><ReviewerRouter /></TarsAuthGate>}></Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
